import style from "../css/FanduEarnBanner.module.css";

import fpCoin from "../../../icons/coin.svg";

export default function FanduEarnBanner({
  topText = "BUY",
  bottomText = "Earn",
  number = 10,

  background = "",
  borderColor = "",

  topTextColor = "",
  bottomTextColor = "",

  icon = fpCoin,
}) {
  return (
    <div
      className={style.container}
      style={{
        background,
        borderColor,
      }}
    >
      <div className={style.leftSection}>
        <div className={style.topText} style={{ color: topTextColor }}>
          {topText}
        </div>

        <div className={style.topText} style={{ color: bottomTextColor }}>
          {bottomText}
        </div>
      </div>

      <div className={style.number}>{number}</div>

      <img src={icon} alt="" className={style.coin} />
    </div>
  );
}
